import React from 'react';

import appConfigs from '@nerdwallet/app-config';

import { WithURLRecord } from '../../components/url-record';
import type { UrlRecordOptions } from '../../components/url-record';
import getTaxonomy from '../../lib/page-taxonomy';

import HACResults, { HACProps } from './hac-results';

const URL_RECORD_OPTIONS: UrlRecordOptions = {
  url: () =>
    `${appConfigs.SITE_BASE_URL}/mortgages/how-much-house-can-i-afford`,
  metadataOptions: () => {
    return {
      nerdLayoutMappings: { pageTaxonomy: getTaxonomy('hac') },
      driverPageName: 'mortgages_home_affordability_calculator',
    };
  },
};
const HACResultsWrapper = (props: HACProps): JSX.Element => {
  return (
    <WithURLRecord
      {...props}
      options={URL_RECORD_OPTIONS}
      component={HACResults}
    />
  );
};

export default HACResultsWrapper;
